import { Col, PageHeader, Row } from 'antd';
import { Link, useParams } from 'react-router-dom';
import React, { ReactElement, useEffect, useState } from 'react';

import useFetch from '../hooks/fetcher';

const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

// response model from backend
type PlantListType = {
    common_name: { count: string; data: { common_name: string }[] };
    synonyms: { count: string; data: { synonyms: string }[] };
    botanical_name: { count: string; data: { botanical_name: string }[] };
    pinyin: { count: string; data: { pinyin: string }[] };
    chinese_pharmaceutical_name: { count: string; data: { chinese_pharmaceutical_name: string }[] };
};

type CategoryType = 'common_name' | 'synonyms' | 'botanical_name' | 'pinyin' | 'chinese_pharmaceutical_name';
const categories: Array<CategoryType> = [
    'common_name',
    'synonyms',
    'botanical_name',
    'pinyin',
    'chinese_pharmaceutical_name',
];

const renderItem = (title: string, table: string, column: string, botanicalId: string, key: number): ReactElement => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'space-between',
        }}
        key={key}
    >
        <Link to={`/plant/network/${table}/${column}/${title}/${botanicalId}`}>{title}</Link>
        <span>-</span>
    </div>
);

const list = (cat: CategoryType, result: any, key: number): ReactElement => (
    <div key={key}>
        <div style={{ fontWeight: 'bold' }}>
            {cat}
            <span style={{ float: 'right' }}>{result[cat]?.count} results</span>
        </div>
        {result[cat]?.data.map((item: any, index: number) => {
            return renderItem(item[cat], 'placeholder', cat, item.botanical_id, index);
        })}
    </div>
);

const PagePlantCategoryList: React.FC = () => {
    const [result, setResult] = useState<PlantListType>();
    const { category, keyword } = useParams<any>();
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const gutterH = 16;
    const gutterV = 16;
    const colHelperProps = {
        xs: 0,
        sm: 0,
        md: 2,
        lg: 5,
        xl: 7,
    };
    const colContentProps = {
        xs: 24,
        sm: 24,
        md: 20,
        lg: 14,
        xl: 10,
    };

    useEffect(() => {
        get('/api/plant_idx_all.php', { category, keyword }).then((r) => setResult(r));
    }, []);
    return (
        <div>
            <PageHeader
                title={'Searched keyword: ' + keyword}
                subTitle={'category: ' + category}
                style={{ marginBottom: '10vh' }}
            />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps}>
                    {categories.map((cat: CategoryType, key) => {
                        return result && result[cat] ? list(cat, result, key) : null;
                    })}
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
        </div>
    );
};

export default PagePlantCategoryList;
